var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_c('v-btn',_vm._g({attrs:{"text":"","x-small":""},on:{"click":_vm.goToViewRequest}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-magnify")])],1)],1)]}}])},[_c('span',[_vm._v(" View request details")])])
}
var staticRenderFns = []

export { render, staticRenderFns }